export type Organisation = {
  id: number;
  logo: string;
  name: string;
  type: OrganisationType;
  activity: OrganisationActivity;
  location: string;
  address: string;
  zipCode: string;
  country: string;
  website: string;
};

export type OrganisationType = (typeof OrganisationTypeValues)[number];
export const OrganisationTypeValues = [
  '',
  'ASSOCIATION',
  'ENTERPRISE',
  'LOCAL_AUTHORITY',
  'INDIVIDUAL',
  'OTHER',
] as const;

export type OrganisationActivity = (typeof OrganisationActivityValues)[number];
export const OrganisationActivityValues = [
  '',
  'FESTIVAL',
  'TOUR',
  'VENUE',
] as const;
